/**
 * Tracks the most recent Sentry error event ID so we can link a feedback
 * submission to a crash the user just experienced.
 *
 * Only counts errors that happened within RECENT_WINDOW_MS — linking a
 * feedback to a 30-minute-old error is misleading.
 */

const RECENT_WINDOW_MS = 2 * 60 * 1000; // 2 minutes

let lastErrorEventId: string | null = null;
let lastErrorTimestamp = 0;

export function recordError(eventId: string) {
  lastErrorEventId = eventId;
  lastErrorTimestamp = Date.now();
}

export function getRecentErrorEventId(): string | undefined {
  if (!lastErrorEventId) return undefined;
  if (Date.now() - lastErrorTimestamp > RECENT_WINDOW_MS) return undefined;
  return lastErrorEventId;
}
